import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-heart-rate",
  templateUrl: "./med-icon-heart-rate.component.html",
})
export class MedIconHeartRateComponent extends SvgMixinComponent {}
